import { hasMigratedToVectorDefault, markMigratedToVectorDefault } from './dashboardCache';
import { isVectorDashboardId } from './vectorDashboardTemplate';
import { apiListDashboards, apiUpdateDashboard } from './dashboardApi';

/**
 * One-time per-user migration: demote personal dashboards that were auto-marked
 * default before Vector Dashboard became the org-wide default. Vector is default
 * when no personal row has is_default=true.
 */
export async function migratePersonalDefaultsToVector(email, list) {
  if (!email || hasMigratedToVectorDefault(email)) return list;

  const stalePersonalDefaults = (list || []).filter(
    (d) => d.is_default && !isVectorDashboardId(d.id),
  );

  if (stalePersonalDefaults.length > 0) {
    await Promise.all(
      stalePersonalDefaults.map((d) =>
        apiUpdateDashboard(d.id, { is_default: false }).catch((err) => {
          console.warn(`Failed to clear is_default on ${d.id}:`, err);
          return null;
        }),
      ),
    );
    try {
      const refreshed = await apiListDashboards();
      markMigratedToVectorDefault(email);
      return refreshed;
    } catch (_err) {
      markMigratedToVectorDefault(email);
      return (list || []).map((d) => (
        stalePersonalDefaults.some((s) => s.id === d.id)
          ? { ...d, is_default: false }
          : d
      ));
    }
  }

  markMigratedToVectorDefault(email);
  return list;
}
